import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { BehaviorSubject, Observable, Observer, Subject } from 'rxjs';

interface ConfigBtns  {
    btnOkText: string;
    btnCancelText: string;
}

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogsService {

    constructor(
        private confirmationService: ConfirmationService
    ) { }

    private config: Subject<ConfigBtns> = new BehaviorSubject<ConfigBtns>(undefined);
    config$: Observable<ConfigBtns> = this.config.asObservable();

    public confirm(title: string, message: string,
            btnOkText: string = 'Ok', btnCancelText: string = 'Cancel'): Observable<boolean> {

        this.config.next({ btnOkText, btnCancelText });

        return new Observable((observer: Observer<boolean>) => {
            this.confirmationService.confirm({
                key: 'confirmation-dialog',
                message: message,
                header: title,
                accept: () => {
                    observer.next(true);
                    observer.complete();
                },
                reject: () => {
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    }
}
